import { SERVER } from "../environment.constants";

export class LoginUrl {
    public static login: string = SERVER + "/login";
    public static clear: string = LoginUrl.login + "/clear";
    public static publicKey: string = LoginUrl.login + "/publicKey";
    public static checkSession: string = LoginUrl.login + "/checkSession";

    public static account = (email: string): string => `${SERVER}/account/${email}`;
}
